import { Reducer } from "redux"
import { DataFileExplorerType, AuthUserType } from "../../../Actions/Types"
import { AuthAction } from "../../Auth"

interface IDataMapperState {
    [index: string]:
        | {
              schema: any
              data: any[]
          }
        | undefined
}

export type DataMapperState = IDataMapperState

export interface DataMapperAction {
    type: DataFileExplorerType | null
    payload?: {
        id: string
        data?: {
            schema: any
            data: any[]
        }
    }
}

const initialState: DataMapperState = {}

export const ColumnMapReducer: Reducer<
    DataMapperState,
    DataMapperAction | AuthAction
> = (state = initialState, action): DataMapperState => {
    switch (action.type) {
        case DataFileExplorerType.setDataMapper:
            const p = action.payload ? action.payload : undefined
            if (p === undefined || !p.data) return state
            return {
                ...state,
                [p.id]: p.data
            }
        case DataFileExplorerType.clearDataMapper:
            return action.payload
                ? {
                      ...state,
                      [action.payload.id]: undefined
                  }
                : state
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
